import countriesData from './countries-data';
import statesData from './states-data';
import plansList from './plans-list';

export const DEFAULT_APP_LOGO_BLACK =
  'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883624/cclariti/Cclariti-logo.svg';
export const DEFAULT_APP_LOGO_WHITE =
  'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883624/cclariti/Cclariti-logo.svg';

export default {
  plansList,
  images: {
    logoBlack: DEFAULT_APP_LOGO_BLACK,
    logoWhite: DEFAULT_APP_LOGO_WHITE,
  },
  industryTypeOptions: [
    'Acute Care',
    'In-Patient Rehabilitation Facility',
    'Long-Term Acute Care Hospital',
    'Skilled Nursing Facility',
    'Certified Home Health Agency',
    'Hospice',
    'Other',
  ],
  countriesData,
  statesData,
  sessionTypesData: ['Family Portrait ', 'Wedding', 'Senior', 'Newborn', 'Maternity', 'Boudoir', 'Event'],
  supportEmail: 'support@cclariti.com',
  /* paypal: {
    paypalSandboxClientId: 'ASpU9zP46pgSU4lm9NkZsj9iOqyo2Xl8mgUKU0BYdkC2jPYnpj_BrkzJrsvKidHQ662RyNQbrsmy_50G',
    paypalProductionClientId: 'Aef5ft1aV38Vjf6ORdbO6QJaOHDCF-Li17uUYMrN-X7le8LroxknL2eqq-cE7bF5aAR-z_9zhp-CMD_k',
    paypalMode: 'sandbox',
  }, */
  sentry: {
    dsn: 'https://c12837c716de40ff9c59cf6ce9e62b22@sentry.io/273461',
  },
  /* stripe: {
    stripePubklishableKey: 'pk_test_VQIPuFqCqEhyYGIHUB7PyXUh',
    stripeConnectKey: 'ca_Bt7PxESpaND9OZq5OykPw9EQCLopspxN',
  }, */
  currencyCodes: ['AUD', 'USD', 'CAD', 'EUR', 'GBP', 'NZD'],
};



// WEBPACK FOOTER //
// ./src/lib/constants/index.js